<form [formGroup]="form" class="cass-contact-details-form">
	<mat-form-field>
		<mat-label>{{ "ORDER.CONTACT_DETAILS.FIRST_NAME" | translate }}</mat-label>
		<input matInput formControlName="firstName" required id="firstName" name="firstName" autocomplete="given-name">
		<mat-error [cassErrorForFormControl]="firstName"></mat-error>
	</mat-form-field>
	<mat-form-field>
		<mat-label>{{ "ORDER.CONTACT_DETAILS.LAST_NAME" | translate }}</mat-label>
		<input matInput formControlName="lastName" required id="lastName" name="lastName" autocomplete="family-name">
		<mat-error [cassErrorForFormControl]="lastName"></mat-error>
	</mat-form-field>
	<mat-form-field>
		<mat-label>{{ "ORDER.CONTACT_DETAILS.ADDRESS_1" | translate }}</mat-label>
		<input matInput formControlName="address1" required id="address1" name="address1" autocomplete="address-line1">
		<mat-error [cassErrorForFormControl]="address1"></mat-error>
	</mat-form-field>
	<mat-form-field>
		<mat-label>{{ "ORDER.CONTACT_DETAILS.ADDRESS_2" | translate }}</mat-label>
		<input matInput formControlName="address2" id="address2" name="address2" autocomplete="address-line2">
		<mat-error [cassErrorForFormControl]="address2"></mat-error>
	</mat-form-field>
	<mat-form-field>
		<mat-label>{{ "ORDER.CONTACT_DETAILS.CITY" | translate }}</mat-label>
		<input matInput formControlName="city" required id="city" name="city" autocomplete="address-level2">
		<mat-error [cassErrorForFormControl]="city"></mat-error>
	</mat-form-field>
	<mat-form-field *ngIf="showStateField">
		<mat-label>{{ "ORDER.CONTACT_DETAILS.STATE" | translate }}</mat-label>
		<input matInput formControlName="state" id="state" name="state" autocomplete="address-level1">
		<mat-error [cassErrorForFormControl]="state"></mat-error>
	</mat-form-field>
	<mat-form-field *ngIf="_showCountry">
		<!-- hidden until configurable as it is unlikely to be used at most sites and not as TS -->
		<mat-label>{{ "ORDER.CONTACT_DETAILS.COUNTRY" | translate }}</mat-label>
		<input matInput formControlName="country" id="country" name="country" autocomplete="country-name">
		<mat-error [cassErrorForFormControl]="country"></mat-error>
	</mat-form-field>
	<mat-form-field>
		<mat-label>{{ "ORDER.CONTACT_DETAILS.POSTCODE" | translate }}</mat-label>
		<input matInput formControlName="zipcode" required id="zipcode" name="zipcode" autocomplete="postal-code">
		<mat-error [cassErrorForFormControl]="zipcode"></mat-error>
	</mat-form-field>
	<mat-form-field>
		<mat-label>{{ "ORDER.CONTACT_DETAILS.PHONE" | translate }}</mat-label>
		<input matInput formControlName="phone" required type="number" id="phone" name="phone" autocomplete="tel">
		<mat-error [cassErrorForFormControl]="phone"></mat-error>
	</mat-form-field>
	<mat-form-field>
		<mat-label>{{ "ORDER.CONTACT_DETAILS.EMAIL" | translate }}</mat-label>
		<input matInput formControlName="email" required id="email" name="email" autocomplete="email">
		<mat-error [cassErrorForFormControl]="email"></mat-error>
	</mat-form-field>
	<mat-checkbox formControlName="createAccount" matInput color="primary" (change)="createAccountChanged()" *ngIf="allowAccountCreation">
		{{ "ORDER.CONTACT_DETAILS.CREATE_ACCOUNT_CHECKBOX" | translate}}
	</mat-checkbox>
	<mat-form-field *ngIf="showPasswordField">
		<mat-label>{{ "ORDER.CONTACT_DETAILS.PASSWORD" | translate }}</mat-label>
		<input matInput type="{{ isPasswordShown ? 'text' : 'password' }}" formControlName="password" cassErrorForFormControlName>
		<button mat-icon-button matSuffix type="button" (click)="isPasswordShown = !isPasswordShown">
			<mat-icon>{{ isPasswordShown ? 'visibility_off' : 'visibility' }}</mat-icon>
		</button>
		<mat-error [cassErrorForFormControl]="password"></mat-error>
	</mat-form-field>
</form>
